export const assets = {
  logo: "https://static.lumi.new/90/90780d3e0e5e5c46f70ed4649948fe40.webp",
  keyVisual: "https://static.lumi.new/90/901ad82aba45e43a69770391148f7b35.webp",
  productSetTall: "https://static.lumi.new/86/8687271cbffba39fabadbec68f2c6f85.webp",
  poster: "https://static.lumi.new/f2/f20fd91792b635dd3662feebe91480f7.webp",
  productSet: "https://static.lumi.new/d0/d05b90aeeac7c047d58c9f91d2a90623.webp",
  productSetMobile: "https://static.lumi.new/eb/ebb51d984277416badb009064a0ca2ed.webp",
  bottle: "https://static.lumi.new/68/683927b7b97d1d125f5e5fd1de2f636d.webp",
  bottleMobile: "https://static.lumi.new/7a/7af546e27f9107822d99fbcdb60c0fd0.webp",
  concert: "https://static.lumi.new/22/22bf67c19641f2d8777c2234d17e335a.webp",
  aboutStage: "https://static.lumi.new/5e/5eb32f57a8a69084a9f9d1753ba6ebe3.webp",
  spray: "https://static.lumi.new/b1/b1e9d1cbe963d3b478457cec96691804.webp",
  dailyLife: "https://static.lumi.new/d8/d8e93cda5130021a391bad3d586a3beb.webp",
  afterShow: "https://static.lumi.new/e4/e4c031ae8070adf38edd271274dcdcb5.webp",
  everyday: "https://static.lumi.new/94/94a2f06f2b5f255800bd0b88325b9c8a.webp",
  stage: "https://static.lumi.new/df/dff5ce14d00af973b78993f0a9bc83e3.png",
  bottleSilk: "https://static.lumi.new/10/10f01c26002a7d9924d3562711fc50d0.webp",
  giftBox: "https://static.lumi.new/04/047aae49a72eb0004d2b66c4195bf993.webp",
  bgDesktop: "https://static.lumi.new/cd/cdef9e7fa698e0a1af1020dec100c475.webp",
  bgMobile: "https://static.lumi.new/f9/f928e747b31039bdb841befc208ee8fa.webp",
}
